import { render, staticRenderFns } from "./ZinusShortCutWebpart.vue?vue&type=template&id=6df732c5"
import script from "./ZinusShortCutWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ZinusShortCutWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports